export default __webpack_public_path__ + "static/e-spres-oh_logo-56b7b748abf8ed5dc47bcaded08cb991.svg";